import { createContext } from 'react';
import type { CreateInput, Customer, ID, UpdateInput } from '@/types';

export interface CustomerContextValue {
  customers: Customer[];
  isLoading: boolean;
  /** `null` when the plan is unlimited. */
  remainingSlots: number | null;
  canAddCustomer: boolean;
  createCustomer: (input: Omit<CreateInput<Customer>, 'businessId'>) => Promise<Customer>;
  updateCustomer: (id: ID, patch: UpdateInput<Customer>) => Promise<void>;
  deleteCustomer: (id: ID) => Promise<void>;
  toggleFavourite: (id: ID) => Promise<void>;
}

export const CustomerContext = createContext<CustomerContextValue | null>(null);
